export default __webpack_public_path__ + "static/media/logo.b39cc441.jpeg";